import { Link } from "react-router-dom";
import { Mail, MapPin, Phone, ArrowUpRight } from "lucide-react";
import Logo from "@/components/Logo";

export const Footer = () => {
  return (
    <footer
      className="bg-[#0F172A] text-white"
      data-testid="site-footer"
    >
      <div className="kt-container py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Logo size={48} inverse />
            <p className="mt-6 text-sm text-zinc-400 leading-relaxed max-w-md">
              CV. Komunika Teknik — penyedia solusi teknologi informasi,
              pengembangan sistem informasi, dan pengadaan perangkat TI
              terpercaya untuk pemerintah, BUMN, dan korporasi di Indonesia.
            </p>
            <div className="kt-divider-red mt-6" />
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-zinc-400">
              Navigasi
            </h4>
            <ul className="mt-5 space-y-3 text-sm">
              {[
                { to: "/", label: "Beranda" },
                { to: "/layanan", label: "Layanan" },
                { to: "/portfolio", label: "Portfolio" },
                { to: "/tentang", label: "Tentang Kami" },
                { to: "/kontak", label: "Kontak" },
              ].map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-zinc-300 hover:text-white inline-flex items-center gap-1"
                    data-testid={`footer-nav-${l.label
                      .toLowerCase()
                      .replace(/\s+/g, "-")}`}
                  >
                    {l.label}
                    <ArrowUpRight size={14} className="opacity-60" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-zinc-400">
              Kontak Kami
            </h4>
            <ul className="mt-5 space-y-4 text-sm text-zinc-300">
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-[#DC2626] mt-0.5 shrink-0" />
                <span>
                  Kantor Pusat — Tarakan, Kalimantan Utara
                  <br />
                  Jl. Yos Sudarso RT. 16 No. 28,
                  <br />
                  Selumit, Tarakan Tengah
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={18} className="text-[#DC2626] shrink-0" />
                <a href="mailto:info@komunikateknik.online" className="hover:text-white">
                  info@komunikateknik.online
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={18} className="text-[#DC2626] shrink-0" />
                <a href="tel:+6285246286550" className="hover:text-white">
                  +62 852-4628-6550
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 text-xs text-zinc-500">
          <span>© {new Date().getFullYear()} CV. Komunika Teknik. All rights reserved.</span>
          <span className="font-mono-kt">v1.0 · Indonesia</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
